export const FLOWER = 'flower'
export const SATIVA = 'sativa'
export const INDICA = 'indica'
export const HYBRID = 'hybrid'
